import { render, staticRenderFns } from "./xyhj.vue?vue&type=template&id=6676bd55&scoped=true&"
import script from "./xyhj.vue?vue&type=script&lang=js&"
export * from "./xyhj.vue?vue&type=script&lang=js&"
import style0 from "./xyhj.vue?vue&type=style&index=0&id=6676bd55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676bd55",
  null
  
)

export default component.exports